import React, { useEffect, useRef, useState } from "react";
import axios from 'axios';
import {toast} from 'react-toastify';
import {
  Divider,
  Grid,
  Backdrop,
  Typography
} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import {useNavigate, useParams} from "react-router-dom";
import { DocumentOverviewAPI } from "../../functions/apicall";
import SentenceTable from "../../components/SentenceTable";
import WordsSVG from "../../assets/media/Icon_Words.svg";
import SentencesSVG from "../../assets/media/Icon_lines.svg";
import PageSVG from '../../assets/media/Pages.svg';
import SentimentDoughnut from "../../components/SentimentDoughnut";
import SentimentLabel from "../../components/SentimentLabel";
import DocumentStatusLabel from "../../components/DocumentStatusLabel";
import ProfanityLabel from "../../components/ProfanityLabel";
import Box from "../../components/base/Box";

const DocumentOverview = (props) => {
  const { caseId, docId } = useParams();
  const [rowData, setRowData] = useState(null);
  const [docData, setDocData] = useState(null);
  const [ loading, setLoading ] = useState(true);
  const [ initialLoading, setInitialLoading ] = useState(true);
  const [ tableLoading, setTableLoading ] = useState(true);
  const [ page, setPage ] = useState(1);
  const [ totalPages, setTotalPages ] = useState(null);
  const [documentUrl, setDocumentUrl] = useState(false);
  const sentenceTableRef = useRef()
  const PAGE_SIZE=10;

  const fetchDocumentData = async (p_page, showError = true, showLoading = true) => {
    if (rowData && showLoading) {
      setTableLoading(true);
    }

    const body = {
      file_id: docId 
    }
    const documentData = await DocumentOverviewAPI(page, PAGE_SIZE, body, showError);
    if (!docData) {
      if(showLoading) {
        setDocumentUrl(documentData.url);
      }
      setDocData(documentData);
      setTotalPages(documentData.totalPages);
    }

    setRowData(documentData.sentences_analysis);
    setInitialLoading(false)
  };

  const MINUTE_MS = 10000;

  useEffect(() => {
    const interval = setInterval(() => {
      fetchDocumentData(null, false, false);
    }, MINUTE_MS);

    return () => clearInterval(interval);
  }, [page]);

  useEffect(() => {
    fetchDocumentData();
  }, [page]);

  useEffect(() => {
    if (rowData) {
      setTableLoading(false);
    }
    else {
      setTableLoading(true);
    }
  }, [rowData]);
  
  useEffect(() => {
    if (docData) {
      setLoading(false);
    }
  }, [docData]);

  return (
    <>
      { loading ?
        <Backdrop
          sx={{ color: '#fff', zIndex: '1500' }}
          open={loading}
          // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      :
        <Grid container spacing={2} className="maindivpage">
          <Grid md={12} sm={12} xs={12} lg={12}>
            <h2 className="pagehead">Document Overview</h2>
          </Grid>

          <div
            className="caseCardHolder"
          >
            <div className="caseCard1" style={{ flexBasis: "55%", display: 'flex', flexDirection: 'column', gridGap: '40px', gap: '40px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div style={{ display: "flex", flexDirection: 'column', gap: '24px' }}>
                  <div style={{fontSize: '20px'}}>Document Details</div>
                  <div style={{ display: "flex", flexDirection: 'column', gap: "8px", wordWrap: 'break-word', maxWidth: '250px' }}>
                    <div style={{ color: "#402E46", opacity: 0.7, fontSize: '17px' }}>Document Name</div>
                    <div>{docData.file_name}</div>
                  </div>
                </div>
                
                <Box>
                  <Box sx={{ marginBottom: "10px", color: "#402E46", opacity: 0.7, fontSize: '17px' }}>Document Level Sentiment Analysis</Box>
                  <div style={{ display: "flex", flexDirection: 'row', gap: '24px' }}>
                    {/* Disabled Group */}
                    {/* <div style={{ display: "flex", flexDirection: 'column', gap: "8px" }}>
                      <div style={{ color: "#402E46", opacity: 0.7 }}>Group</div>
                      <div>{docData.group}</div>
                    </div> */}
                    <div style={{ display: "flex", flexDirection: 'column', gap: "8px" }}>
                      <div style={{ color: "#402E46", opacity: 0.7 }}>Status</div>
                      <DocumentStatusLabel status={docData.status} />
                    </div>
                    <div style={{ display: "flex", flexDirection: 'column', gap: "8px" }}>
                      <Box sx={{ color: "#402E46", opacity: 0.7 }}>Sentiment</Box>
                      <SentimentLabel sentiment={docData.sentiement_label} />
                    </div>
                    <div style={{ display: "flex", flexDirection: 'column', gap: "8px" }}>
                      <div style={{ color: "#402E46", opacity: 0.7 }}>Profanities</div>
                      <ProfanityLabel value={docData.profanity} />
                    </div>
                  </div>
                </Box>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
                <div style={{ display: "flex", flexWrap: 'wrap', gap: '40px' }}>
                  <div style={{ display: "flex", gap: "16px" }}>
                    <div style={{ backgroundColor: "#E2E2E2", borderRadius: "100%", paddingLeft: "4px", paddingRight: "4px", paddingTop: '3px', width: "48px",}}>
                      {/* <DescriptionOutlinedIcon sx={{ fontSize: '2.25rem' }}/> */}
                      <img src={PageSVG} />
                    </div>

                    <div>
                      <Typography style={{ fontSize: '16px', color: '#402E46', opacity: '0.7' }}>No. of Pages</Typography>
                      <Typography style={{ fontSize: "16px" }}>{docData.num_of_pages}</Typography>
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: "16px" }}>
                    <div style={{ backgroundColor: "#E2E2E2", borderRadius: "100%", paddingLeft: "4px", paddingRight: "4px", paddingTop: "3px", width: "48px" }}>
                      <img src={SentencesSVG} />
                    </div>

                    <div>
                      <Typography style={{ fontSize: '16px', color: '#402E46', opacity: '0.7' }}>No. of Sentences</Typography>
                      <Typography style={{ fontSize: "16px" }}>{docData.num_of_sentences}</Typography>
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", gap: "55px" }}>
                  <div style={{ display: "flex", gap: "16px" }}>
                    <div style={{ backgroundColor: "#E2E2E2", borderRadius: "100%", paddingLeft: "4px", paddingRight: "4px", paddingTop: "3px", width: "48px" }}>
                      <img src={WordsSVG} />
                    </div>

                    <div>
                      <Typography style={{ fontSize: '16px', color: '#402E46', opacity: '0.7' }}>No. of Words</Typography>
                      <Typography style={{ fontSize: "16px" }}>{docData.num_of_words}</Typography>
                    </div>
                  </div>

                  {/* <div style={{ display: "flex", alignItems: "center", gap: "8px" }}> */}
                  {/*   <div style={{ backgroundColor: "#E2E2E2", borderRadius: "100%", paddingLeft: "4px", paddingRight: "4px", paddingTop: "3px", width: "fit-content" }}> */}
                  {/*     <LocalOfferOutlinedIcon/> */}
                  {/*   </div> */}

                  {/*   <div style={{ backgroundColor: "#ddeeff", paddingLeft: "10px", paddingRight: "10px", paddingTop: "5px", paddingBottom: "5px", fontSize: "16px", borderRadius: "8px", color: "#402E46" }}> */}
                  {/*     #humorous */}
                  {/*   </div> */}

                  {/*   <div style={{ backgroundColor: "#ddeeff", paddingLeft: "10px", paddingRight: "10px", paddingTop: "5px", paddingBottom: "5px", fontSize: "16px", borderRadius: "8px", color: "#402E46" }}> */}
                  {/*     #tue */}
                  {/*   </div> */}
                  {/* </div> */}
                </div>
              </div>
            </div>

            <div style={{ flexBasis: '45%', padding: "16px", backgroundColor: "white", boxShadow: "0px 13px 32px #00000029", borderRadius: "15px" }}>
              <Grid style={{ fontSize: '20px', marginBottom: '20px', paddingLeft: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>Sentence Level Sentiment Analysis</Box>
              </Grid>

              <Grid container sx={{ display: 'flex', flexDirection: 'column', gap: '12px', height: '75%', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ marginTop: "10px", width: "75%" }}>
            {(!!docData.positive_sentiment || !!docData.neutral_sentiment || !!docData.negative_sentiment) ?
                  <SentimentDoughnut 
                    positive={docData.positive_sentiment}
                    neutral={docData.neutral_sentiment}
                    negative={docData.negative_sentiment}
                  />
                  : <Box sx={{textAlign: 'center', fontSize: '2rem'}}>-</Box>
                }
                </Box>

                {/* { Math.sign(docData.sentiment_score) == "-1" ? */}
                {/*   <Grid md={6} lg={6} sm={6} xs={6}> */}
                {/*     <DonutChart */}
                {/*       data={[ */}
                {/*         (docData.sentiment_score.toFixed(1) * 50 * -1) - 100, */}
                {/*         docData.sentiment_score.toFixed(1) * 50 * -1, */}
                {/*       ]} */}
                {/*       colors={["#edc7d0", "#D12953"]} */}
                {/*       text={`${docData.sentiment_score.toFixed(1)}`} */}
                {/*       textColor="#D12953" */}
                {/*     /> */}
                {/*   </Grid> */}
                {/* : */} 
                {/*   <Grid md={6} lg={6} sm={6} xs={6}> */}
                {/*     <DonutChart */}
                {/*       data={[ */}
                {/*         (docData.sentiment_score.toFixed(1) * 50) - 100, */}
                {/*         docData.sentiment_score.toFixed(1) * 50 */}
                {/*       ]} */}
                {/*       colors={["#c9f3de", "#14804A"]} */}
                {/*       text={ docData.sentiment_score.toFixed(1) == '0.0' ? */}
                {/*         ` ${docData.sentiment_score.toFixed(1)}` */} 
                {/*         : */} 
                {/*         `+${docData.sentiment_score.toFixed(1)}` */}
                {/*       } */}
                {/*       textColor="#14804A" */}
                {/*     /> */}
                {/*   </Grid> */}
                {/* } */}
              </Grid>
            </div>
          </div>

          <Grid style={{ marginTop: 30, width: "100%", marginRight: "20px" }} ref={sentenceTableRef}>
            { initialLoading ? 
              <Grid>
                <CircularProgress 
                  style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'center'
                  }} 
                />
              </Grid>
            : 
              rowData.length === 0 ? (
                <Grid>
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "10%",
                      lineHeight: 2,
                      fontWeight: "100",
                    }}
                  >
                    It seems there is nothing here!
                  </p>
                </Grid>
              ) : (
                <SentenceTable 
                  rowData={rowData}
                  url={docData.url}
                  totalRows={docData.totalItems}
                  loading={tableLoading}
                  getPage={(number) => {
                    setPage(number);
                    sentenceTableRef.current.scrollIntoView()
                  }}
                  currentPage={page}
                  totalPages={totalPages}
                />
              )
            }
          </Grid>
          

          <Grid style={{ marginTop: 30, width: "100%", marginRight: "20px", boxShadow: "0px 5px 15px #00000029", overflow: 'hidden', borderRadius: '18px', borderTopLeftRadius: '18px', borderTopRightRadius: '18px' }}>
            <Grid style={{ backgroundColor: 'white', padding: '20px'}}>
              {docData.file_name} 
            </Grid>

            <iframe src={documentUrl} width={"100%"} height={"800px"} />
          </Grid>
        </Grid>
      }
    </>
  )
}

export default DocumentOverview;
